import { useEffect } from 'react';

const targetOrigin = process.env.REACT_APP_AKA_PROJEKT_ORIGIN as string;

/**
 * The purpose of this is to "auto-login" the user towards the Visa Faktura site
 */

function AhSso() {
  useEffect(() => {
    let targetWindow = window.opener;
    let params = new URL(document.location.href).searchParams;
    //Post to origin
    targetWindow.postMessage(Object.fromEntries(params.entries()), targetOrigin);
    window.close();
  }, []);
  return null;
}

export default AhSso;